module.exports = __webpack_public_path__ + "static/img/A6231_test.ca3a0af2.png";